/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  DashboardTaskResponse,
  LocationCounts,
  ReportRequest,
  ReportResponse,
  TodoResponse,
} from "./data-contracts";
import { HttpClient, RequestParams } from "./http-client";

export class Reports<
  SecurityDataType = unknown,
> extends HttpClient<SecurityDataType> {
  /**
   * No description
   *
   * @tags reporting-controller
   * @name GetLocationReport
   * @request GET:/reports/locations/{locationId}
   * @secure
   * @response `200` `ReportResponse` OK
   */
  getLocationReport = (
    locationId: string,
    query: {
      request: ReportRequest;
    },
    params: RequestParams = {},
  ) =>
    this.request<ReportResponse, any>({
      path: `/reports/locations/${locationId}`,
      method: "GET",
      query: query,
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags reporting-controller
   * @name GetLocationTodos
   * @request GET:/reports/locations/{locationId}/todos
   * @secure
   * @response `200` `(TodoResponse)[]` OK
   */
  getLocationTodos = (locationId: string, params: RequestParams = {}) =>
    this.request<TodoResponse[], any>({
      path: `/reports/locations/${locationId}/todos`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags reporting-controller
   * @name GetLocationTodosAndTasks
   * @request GET:/reports/locations/{locationId}/todosTasks
   * @secure
   * @response `200` `DashboardTaskResponse` OK
   */
  getLocationTodosAndTasks = (locationId: string, params: RequestParams = {}) =>
    this.request<DashboardTaskResponse, any>({
      path: `/reports/locations/${locationId}/todosTasks`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags reporting-controller
   * @name GetLocationsTodos
   * @request GET:/reports/locations/todos
   * @secure
   * @response `200` `(TodoResponse)[]` OK
   */
  getLocationsTodos = (params: RequestParams = {}) =>
    this.request<TodoResponse[], any>({
      path: `/reports/locations/todos`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags reporting-controller
   * @name GetLocationUserActiveCampaigns
   * @request GET:/reports/location/activeCampaigns
   * @secure
   * @response `200` `Record<string,number>` OK
   */
  getLocationUserActiveCampaigns = (params: RequestParams = {}) =>
    this.request<Record<string, number>, any>({
      path: `/reports/location/activeCampaigns`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags reporting-controller
   * @name GetLocationUserActiveCampaignsWithCounts
   * @request GET:/reports/location/activeCampaignsWithCounts
   * @secure
   * @response `200` `Record<string,LocationCounts>` OK
   */
  getLocationUserActiveCampaignsWithCounts = (params: RequestParams = {}) =>
    this.request<Record<string, LocationCounts>, any>({
      path: `/reports/location/activeCampaignsWithCounts`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags reporting-controller
   * @name GetLocationUserActiveCampaignsWithCountsByLocation
   * @request GET:/reports/location/activeCampaignsWithCounts/{locationId}
   * @secure
   * @response `200` `LocationCounts` OK
   */
  getLocationUserActiveCampaignsWithCountsByLocation = (
    locationId: string,
    params: RequestParams = {},
  ) =>
    this.request<LocationCounts, any>({
      path: `/reports/location/activeCampaignsWithCounts/${locationId}`,
      method: "GET",
      secure: true,
      ...params,
    });
}
